import { Icon20InfinityOutline } from '@vkontakte/icons';
import { Link } from '@vkontakte/vkui';
import React, { memo, useCallback, useRef, useState } from 'react';
import { helpAutoUploadHref } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { sendDwhTooltip } from 'reactApp/modules/dwh/dwh.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './BAZFeatureLineWithTooltip.css';

const name = 'mnz_baz_info_tip';

export const BAZFeatureLineWithTooltip = memo(() => {
    const ref = useRef<HTMLDivElement>(null);
    const [showTip, setShowTip] = useState(false);

    const handleEnter = useCallback(() => {
        setShowTip(true);
    }, []);

    const handleShow = useCallback(() => {
        sendDwhTooltip({ name });
    }, []);

    const handleClick = useCallback(() => {
        setShowTip(false);
        sendDwhTooltip({ action: 'click', name });
    }, []);

    const handleClose = useCallback(() => {
        setShowTip(false);
        sendDwhTooltip({ action: 'close', name });
    }, []);

    return (
        <>
            <div className={styles.wrapper} ref={ref}>
                <div className={styles.container} onMouseLeave={handleClose}>
                    {showTip && (
                        <FloatingTooltip
                            target={ref}
                            placement={ETooltipPlacement.top}
                            appearance={ETooltipAppearance.blue}
                            className={styles.root}
                            closeClassName={styles.closeClassName}
                            size={ETooltipSize.fit}
                            onClose={handleClose}
                            onShow={handleShow}
                            closeOnScroll
                            topOffset={-10}
                            leftOffset={20}
                            qaId={'baz-feature-tip'}
                        >
                            <div className={styles.content}>
                                <p>
                                    Фото и видео с телефона теперь
                                    <br />
                                    не занимают место в Облаке
                                </p>
                                <Link href={helpAutoUploadHref} target="_blank" onClick={handleClick}>
                                    Как это работает
                                </Link>
                            </div>
                        </FloatingTooltip>
                    )}
                </div>
                <div className={styles.description} onMouseEnter={handleEnter}>
                    <Icon20InfinityOutline /> <p>Безлимит для фото с телефона</p>
                </div>
            </div>
        </>
    );
});

BAZFeatureLineWithTooltip.displayName = 'BAZFeatureLineWithTooltip';
